import TrustpilotReviewAdapter from "./TrustpilotReviewCard";

export default TrustpilotReviewAdapter;
